import React, { useCallback, useMemo } from 'react'
import { Box, Button, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import { useFormikContext } from 'formik'
import UnderlineHeading from '../../../../../components/UnderlineText/UnderlineHeading'
import { useLabels } from '../../../../../utils/hooks/useLabels/useLabels'
import { columns } from './temporalData'
import { useDiscountContext } from '../../../../../utils/hooks/Context/DiscountContext'
import { REPOSITORY } from '../../../../../api/repository/Repository'
import SelectorField from '../../../../../components/Selector/SelectorField'
import { filterOptions } from '../../../../../utils/hooks/useTableFilter/useTableFilterStatus'
import SearchBar from '../../../../../components/SearchBar/SearchBar'
import Selector from '../../../../../components/Selector/Selector'
import { colors } from '../../../../../utils/theme/styles'
import TableLocal from '../../../../../components/Table/TableLocal/TableLocal'

export const defaultOptions = [{ id: null, label: 'Todos', value: null }]

function IndividualDiscount() {
  const { texts } = useLabels()
  const {
    employees,
    handleEmployeesChange,
    totalPages,
    page,
    handleChangePage,
    employeeStatus,
    handleStatusChange,
    handleChangeFilter,
    employeesChanged,
    applyFilters,
    handleChange: handleEmployeeFilter,
    searchValue,
    fillTotalBalance,
    fillAllTotalBalance,
  } = useDiscountContext()
  const { sCentroCosto, sSucursal } = REPOSITORY.local.company.getCompanyData()
  const { values, handleChange } = useFormikContext()
  const changeCostCenter = useCallback((data) => {
    handleChangeFilter('sCentroCosto', data)
  }, [])
  const changeBranchOffice = useCallback((data) => {
    handleChangeFilter('sSucursal', data)
  }, [])
  const tableProps = useMemo(
    () => ({
      updateMyData: handleEmployeesChange,
      columns: columns,
      onEmployeeClick: fillTotalBalance,
      data: employeesChanged,
      withPagination: true,
      pagination: {
        totalPages,
        actualPage: page,
        handlePageChange: handleChangePage,
      },
    }),
    [
      handleEmployeesChange,
      columns,
      employees,
      employeesChanged,
      totalPages,
      page,
      handleChangePage,
    ],
  )
  return (
    <Flex direction="column" h="100%" w={'100%'}>
      <UnderlineHeading
        variant="h5"
        text={texts.select_cost_center_and_office}
      />
      <HStack mt="45px" spacing="47px" w="100%" alignItems="flex-end">
        <Box minW="20%">
          <SelectorField
            name="sCentroCosto"
            title={texts.cost_center}
            options={
              sCentroCosto.slice(0, sCentroCosto.length - 1) || defaultOptions
            }
            handleChange={changeCostCenter}
            titleType="overline"
            placeholder="Todos"
            isClearable
          />
        </Box>
        <Box minW="20%">
          <SelectorField
            name="sSucursal"
            value={values.sSucursal}
            onChange={handleChange}
            handleChange={changeBranchOffice}
            title={texts.branch_office}
            options={sSucursal}
            titleType="overline"
            placeholder="Todas"
            isClearable
          />
        </Box>
        <Box>
          <Button
            onClick={() => {
              const search = searchValue.includes('NN')
                ? { sNombre: searchValue }
                : { sRut: searchValue }
              applyFilters({
                sSucursal: values.sSucursal,
                sCentroCosto: values.sCentroCosto,
                sEstado: [employeeStatus],
                ...search,
              })
            }}
            variant="primary"
          >
            Filtrar nomina
          </Button>
        </Box>
      </HStack>
      <Box mt="35px">
        <UnderlineHeading
          subtext={texts.can_search_collaborator}
          subVariant="caption1"
          variant="h5"
          text={texts.realize_discount}
        />
      </Box>
      <Box mt="28px" h="50%">
        <VStack alignItems="flex-start">
          <HStack justifyContent="space-between" w="100%">
            <HStack justifyContent="flex-start" spacing="20px">
              <Box w="250px">
                <SearchBar
                  handleSearch={handleEmployeeFilter}
                  value={searchValue}
                />
              </Box>
              <Box w="200px">
                <Selector
                  options={filterOptions}
                  placeholder={'Filtrar por'}
                  defaultValue={filterOptions.find(
                    (item) => item.id === employeeStatus,
                  )}
                  onChange={handleStatusChange}
                  isClearable={true}
                  isSearchable={true}
                />
              </Box>
              <Box w="150px">
                <Button
                  onClick={() => {
                    const search = searchValue.includes('NN')
                      ? { sNombre: searchValue }
                      : { sRut: searchValue }
                    applyFilters({
                      sSucursal: values.sSucursal,
                      sCentroCosto: values.sCentroCosto,
                      sEstado: [employeeStatus] || [],
                      ...search,
                    })
                  }}
                  variant="searchbar"
                >
                  Buscar
                </Button>
              </Box>
            </HStack>
            <Box>
              <Button
                variant="white"
                border={`1px solid ${colors.border.default}`}
                w="248px"
                h="32px"
                borderRadius="4px"
                padding="0px"
                onClick={fillAllTotalBalance}
              >
                <Text variant="button">Descontar saldo a todos</Text>
              </Button>
            </Box>
          </HStack>
          {tableProps.data.length > 0 && <TableLocal {...tableProps} />}
        </VStack>
      </Box>
    </Flex>
  )
}

export default IndividualDiscount
